const styles = theme => ({
  title: {
    marginBottom: theme.spacing(3),
    textAlign: 'center',
  },
  button: {
    marginTop: theme.spacing(2),
    minWidth: 200,
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      width: '25%',
    },
  },
})

export default styles
